export const downloadReport = (body: string, fileName: string) => {
  const blob = new Blob([body], { type: 'application/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
};
